import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { getParameterByName, deepCopy, DwActionPreference, DwComponent, DwComponentSectionPreference, DwComponentType, 
         DwEventService, DwExpressionService, DwFormActionConfig, DwFormActionInterceptor, DwFormActionInterceptResult, 
         DwFormActionKeys, DwFormContextMode, DwMenuService, DwMessage, DwMessageSeverity, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, 
         DwSectionBaseComponent, DwSelectLookupComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } 
         from '@devwareapps/devware-cap';
import { number } from 'mathjs';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaData, AppMetaDataLookups, AppMetaDataService, EthosJobNumberEntity } from 'src/app/meta-data/app-meta-data.service';
import { KickoffEntity, KickoffMetaDataItemNames, KickoffMetaDataLookups } from '../../meta-data/kickoff-meta-data.service';
import { KickoffDocumentRepositoryService } from '../../services/kickoff-document-repository.service';
import { HttpClient } from '@angular/common/http';

@DwComponent(
  {
    key: 'create-multiple-kickoffs',
    name: 'Create Multiple Kickoff Documents',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: KickoffMetaDataItemNames.Kickoff,
  }
)
@Component({
  selector: 'app-create-multiple-kickoffs',
  templateUrl: './create-multiple-kickoffs.component.html',
  styleUrls: ['./create-multiple-kickoffs.component.scss']
})
export class CreateMultipleKickoffsComponent extends DwSectionBaseComponent<DwComponentSectionPreference>
{

  newKickoffs: KickoffEntity[] = [];
  jobNumberData: EthosJobNumberEntity[] = [];
  selectedJobNumberId: number;
  jobNumberLookupId = KickoffMetaDataLookups.EthosJobNumberActiveOnlyForKickoff; // 1750;


  addedJobs: EthosJobNumberEntity[] = [];
  message: DwMessage;
  jobNumberIdRequested: number;

  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private kickoffDocumentRepositoryService: KickoffDocumentRepositoryService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private dwEventService: DwEventService,
    private router: Router,
    private dwMenuService: DwMenuService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  setupComponentComplete() {
    this.injectRequestedId();
    this.dwMetaDataFormStateService.addActionInterceptor(this.getFormActionInterceptor());
  }

  injectRequestedId() {
    this.jobNumberIdRequested = getParameterByName(this.router, 'Ethos_JobNumberId');
    if (this.jobNumberIdRequested)
      this.lookupJobNumberIdToAdd(this.jobNumberIdRequested);
  }
  getFormActionInterceptor(): DwFormActionInterceptor {
    const dwMetaDataFormStateService = this.dwMetaDataFormStateService;

    const interceptor: DwFormActionInterceptor = {
      interceptorName: 'kick-off-document-interceptor',
      onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) => {
        const result: DwFormActionInterceptResult = {
          abort: false
        }

        if (actionPref.actionKey != DwFormActionKeys.formSave) {
          return of(result);
        }

        const kickoffDocument: KickoffEntity = dwMetaDataFormStateService.state.formApi.getFormData();

        if (this.addedJobs.length > 0) {

          return this.kickoffDocumentRepositoryService.saveKickoffDocuments(kickoffDocument, this.addedJobs, this.newKickoffs)
            .pipe(map(savedKickoffDocs => {
              result.abort = true;

              //Set form to pristine to remove redirect message
              this.formGroup.markAsPristine();

              this.redirectToGrid();

              this.dwEventService.publishEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(KickoffMetaDataItemNames.Kickoff), {});

              return result;
            }))
        }

      }
    }
    return interceptor;
  }

  redirectToGrid() {
    const url = `/project-tools/kickoff`;
    this.router.navigateByUrl(url);
  }

  lookupJobNumberIdToAdd(id: number) {
    this.kickoffDocumentRepositoryService.getJobInformation(id)
      .subscribe(jobNumber => {
        if (jobNumber) {
          this.jobNumberData.push(jobNumber);
          this.addedJobs = deepCopy(this.jobNumberData);
          this.selectedJobNumberId = null;
        }
      });
  }
  addJobNumber() {
    if (this.selectedJobNumberId == null)
      return;

    const existingJobNumber = this.jobNumberData.find(jn => jn.JobNumberId == this.selectedJobNumberId);

    if (existingJobNumber) {
      this.message = {
        messageBody: "Job number has already been added",
        severity: DwMessageSeverity.error
      };
      return
    }
    this.lookupJobNumberIdToAdd(this.selectedJobNumberId);
    //   this.kickoffDocumentRepositoryService.getJobInformation(this.selectedJobNumberId)
    //     .subscribe(jobNumber => {
    //       this.jobNumberData.push(jobNumber);
    //       this.addedJobs = deepCopy(this.jobNumberData);
    //       this.selectedJobNumberId = null;
    //     });
  }
}